import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Flame, Users, CalendarDays, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { fmtDateTime } from "@/lib/date";

function fmtDate(iso) {
  return fmtDateTime(iso);
}

// Events with the most RSVPs, scoped to the signed-in user's country.
export default function TrendingEvents() {
  const { user } = useAuth();
  const [events, setEvents] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user?.country) return;
    api.get("/events/trending", { params: { country: user.country } })
      .then((r) => setEvents(r.data)).catch(() => {});
  }, [user]);

  if (!events.length) return null;

  return (
    <section className="mb-10" data-testid="trending-events">
      <div className="flex items-center gap-2 mb-4">
        <Flame className="w-5 h-5 text-[#FF7A70]" fill="currentColor" />
        <h2 className="font-display font-extrabold text-lg lg:text-2xl tracking-tight">Trending This Week</h2>
        <button onClick={() => navigate("/events")} className="ml-auto text-sm text-[#E6B34A] font-semibold inline-flex items-center gap-1 hover:gap-2 transition-all">
          All events <ArrowRight className="w-4 h-4" />
        </button>
      </div>
      <div className="flex gap-4 overflow-x-auto pb-2 -mx-1 px-1">
        {events.map((ev, i) => (
          <button
            key={ev.id}
            onClick={() => navigate("/events")}
            data-testid={`trending-event-${ev.id}`}
            className="text-left shrink-0 w-64 rounded-2xl border border-white/10 bg-white/[0.03] overflow-hidden hover:border-white/25 transition-colors"
          >
            {ev.has_cover
              ? <img src={`${api.defaults.baseURL}/events/${ev.id}/cover`} alt={ev.title} className="w-full h-24 object-cover" />
              : <div className="w-full h-24 bg-gradient-to-br from-[#5B7CFA]/20 to-[#E6B34A]/10 flex items-center justify-center"><CalendarDays className="w-7 h-7 text-white/30" /></div>}
            <div className="p-4">
              <div className="flex items-center gap-1.5 text-[#FF7A70] text-xs font-bold"><Flame className="w-3.5 h-3.5" fill="currentColor" /> #{i + 1} · <Users className="w-3.5 h-3.5" /> {ev.attendee_count} going</div>
              <h3 className="font-display font-bold text-base tracking-tight mt-1.5 leading-tight line-clamp-2">{ev.title}</h3>
              <p className="text-xs text-zinc-400 mt-1.5">{fmtDate(ev.starts_at)} · {ev.city || ev.country}</p>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
}
